<template>
    <!-- Новий дизайн: «Назад» і хлібні крихти над заголовком інформаційних сторінок -->
    <nav class="bp-pnav" aria-label="Навігація">
        <button type="button" class="bp-pnav__back" @click="back()"><span class="bp-pnav__ic" v-html="icons.chevronLeft"></span>Назад</button>
        <router-link class="bp-pnav__link" :to="{ name: 'pizza', params: $route.params }">Головна</router-link>
        <span class="bp-pnav__sep" aria-hidden="true" v-html="icons.chevronRight"></span>
        <span class="bp-pnav__here" aria-current="page">{{ title }}</span>
    </nav>
</template>

<script>
import { ICONS } from '@/v2icons'

export default {
    props: ['title'],

    data() {
        return {
            icons: ICONS
        }
    },

    methods: {
        // Прийшли з іншої сторінки сайту — назад туди; відкрили посилання напряму — на головну
        back() {
            if (window.history.state && window.history.length > 1) this.$router.back();
            else this.$router.push({ name: 'pizza', params: this.$route.params });
        }
    }
}
</script>
